import { getWrappedTextStyles, sharedTypographyStyles } from '../FinancialInfoBody.styles';

export const wrappedTextStyles = getWrappedTextStyles(2);

export const wrappedStyles = {
  ...wrappedTextStyles,
  ...sharedTypographyStyles,
};
